module.exports = __webpack_public_path__ + "img/map-bg.40690af7.png";